<script lang="ts">
	// @ts-nocheck
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Radio } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;
</script>

<div class="d-flex flex-direction-column">
	<Radio
		class="d-inline-flex"
		value={true}
		bind:selected={controlOption.params.output}
		size="m"
		id="radio-yrtinrk"
	>
		{capFirstChar($format('on_action', { default: 'on' }))}
	</Radio>
	<Radio
		class="d-inline-flex"
		value={false}
		bind:selected={controlOption.params.output}
		size="m"
		id="radio-caic48q"
	>
		{capFirstChar($format('off_action', { default: 'off' }))}
	</Radio>
</div>
